import React, { useRef } from "react";
import "../scss/Scss/Home.scss";
import { useDetectOutsideClick } from "./useDetectOutsideClick";
import { NavLink } from "react-router-dom";

export default function App() {
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const onClick = () => setIsActive(!isActive);

  const hamburger = () => {
    let nav = document.getElementById("nav");
    nav.classList.toggle("hide");
  };

  return (
    <div className=" menu-hamburger">
      <div className="hamburger" onClick={hamburger}>
        <div className="hamburger__container">
          <input type="checkbox" id="toggle" />
          <div className="hambuger">
            <div className="hambuger__item"></div>
            <div className="hambuger__item"></div>
            <div className="hambuger__item"></div>
          </div>
        </div>
      </div>
      <nav
        className={`nav menu-active  ${isActive ? "active" : "inactive"}`}
        style={{ overflow: "auto" }}
        id="nav"
      >
        <ul>
          <li>
            <NavLink exact to="/" activeClassName="activeLink">
              HOME
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" activeClassName="activeLink">
              ABOUT US
            </NavLink>
          </li>
          <li>
            <NavLink to="/projects" activeClassName="activeLink">
              PROJECTS
            </NavLink>
          </li>
          <li>
            <NavLink to="/culture" activeClassName="activeLink">
              CULTURE
            </NavLink>
          </li>
          <li>
            <NavLink to="/service" activeClassName="activeLink">
              SERVICES
            </NavLink>
          </li>
          <li>
            <NavLink to="/news" activeClassName="activeLink">
              NEWS
            </NavLink>
          </li>
          <li>
            <NavLink to="/community" activeClassName="activeLink">
              COMMUNITY
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" activeClassName="activeLink">
              CONTACT US
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
}
